import { useQuery } from "@tanstack/react-query";

import * as API from "@krea/common/store/banking-data/api";

export const useInstitutionsQuery = ({
  resourceId,
  resourceType,
}: {
  resourceId: string;
  resourceType: string;
}) => {
  return useQuery(
    ["institutions", resourceId, resourceType],
    () => API.getInstitutions(resourceId, resourceType),
    {
      staleTime: Infinity,
    },
  );
};
